import { type FC, Suspense } from 'react';
import { useLazyLoadQuery, graphql } from 'react-relay';

import { SellerReviewsPhotosCarousel } from './SellerReviewsPhotosCarousel.tsx';

import { type SellerReviewsPhotosCarouselRendererQuery } from './__generated__/SellerReviewsPhotosCarouselRendererQuery.graphql.ts';

export const SellerReviewsPhotosCarouselRenderer: FC<{
    sellerId: string;
    noTabs?: boolean;
}> = ({ sellerId, noTabs }) => {
    const { viewer } = useLazyLoadQuery<SellerReviewsPhotosCarouselRendererQuery>(
        graphql`
            query SellerReviewsPhotosCarouselRendererQuery($sellerId: String!) {
                viewer {
                    ...SellerReviewsPhotosCarousel_viewer
                }
            }
        `,
        { sellerId }
    );

    return (
        <Suspense
            fallback={
                <SellerReviewsPhotosCarousel viewer={null} sellerId={sellerId} noTabs={noTabs} />
            }
        >
            <SellerReviewsPhotosCarousel viewer={viewer} sellerId={sellerId} noTabs={noTabs} />
        </Suspense>
    );
};
